<template>
	<div>
		<div class="welcome-login text-center">
			<!-- display the district info -->
            <img v-if="logoSrc" :src="logoSrc" :alt="districtName + ' logo'"/>
            <h3 class="district-name">{{ districtName }}</h3>
			<hr/>

            <h3>Reset Password Challenge</h3>

            <!-- display any messages ( allowing html formatting ) -->
            <div v-if="getActiveMessage"
            	id="formFeedback"
            	:class="getMessageClass"
                v-html="getActiveMessage.content">
            </div>
        </div>
        <form method="post" ref="form" @submit.prevent="validateBeforeSubmit" :action="postEndpoint">
			<input type="hidden" name="_csrftoken" :value="csrfToken" />
			<input type="hidden" name="username" :value="username">
			<input type="hidden" name="pin" :value="pin">
			<input type="hidden" name="email" :value="email">

            <div class="form-group"  :class="{'has-warning': errors.has('answer') }">
                <label for="answer">
                    <em>{{ challenge.text }}</em>
                </label>
                <input 
                    type="text" 
                    class="form-control" 
                    name="answer" 
                    v-model="answer" 
                    v-validate="'required'">
                
                <div v-show="errors.has( 'answer' )">
                    <small class="invalid-feedback">{{ errors.first( 'answer' ) }}</small>
                </div>
            </div>

            <div class="">
                <button 
              		type="submit"
                	class="btn btn-block btn-primary"
                	:disabled="isFormInvalid">
                    Continue
                </button>
            </div>
        </form>
        
        <div class="go-back">
            <a :href="entrypoint"><i class="fas fa-chevron-left"></i> Go Back</a>
        </div>
    </div>
    
</template>
                
<script>
    export default{
        props:{
			csrfToken : "",
        	districtName : "",
			logoSrc : "",
			username : "",
			pin : "",
			email : "",
        	message : {
        		type: Object,
				default: function(){
					return {
						category: "info",
						content: "Please enter the answer to your <br><strong>SECURITY QUESTION</strong>"
					}
				}
			},
            challenge : {
                type: Object,
                default: function(){
                    return {
                        id: "",
                        text:"There was a problem loading your security question"
                    }
                }
            },
            entrypoint : {
				type: String,
				required: true
			},
			postEndpoint : {
				type: String,
				required: true
			}
        },
        data(){
            return{
            	answer: "",
            }
        },
        computed: {
    		isFormInvalid() {
      			return Object.keys( this.fields ).some( key => this.fields[ key ].invalid );
    		},
    		isFormTouched() {
    			return Object.keys( this.fields ).some( key => this.fields[ key ].touched );
    		},
    		getMessageClass() {
    			return "alert alert-" + this.getActiveMessage.category;
    		},
    		getActiveMessage() {
    			if( this.isFormInvalid && this.isFormTouched ){
    				return {
    					category : "warning",
    					content : "Some required fields are missing!"
    				}
    			} else{
    				return this.message;
    			}
    		}

  		},
        methods: {
            validateBeforeSubmit() {
                this.$validator.validateAll().then((result) => {
	                if (result) {
	                    this.$refs.form.submit();
	                    return;
	                }

	                            	});
            }
        }  
    }
</script>